import React from "react"
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import FieldRating_InlineEditableStatefull from "../components/inline-edit/rating-component";

export default function FieldRating_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]


    return <FieldRating_InlineEditableStatefull field={props.field} value={value} onChange={props.onChange}/>

}

